import { SchemaModelFieldType } from '@smx-ui-model/types';
import { Form, Select } from 'antd';
import { memo, Suspense, useMemo } from 'react';

import { DynamicListEntity, DynamicListEntityProps } from './dynamic-list-entity';

interface FieldDynamicListEntityProps<T, K, M> extends DynamicListEntityProps<T, K, M> {
    field: SchemaModelFieldType;
    message?: string;
}

export const FieldDynamicListEntity = <T, K = any, M = any>({
    field,
    style,
    message,
    ...restProps
}: FieldDynamicListEntityProps<T, K, M>) => {
    const fallback = (
        <>
            {
                <Form.Item label={field.title} required={field.isRequired}>
                    <Select disabled={field.isReadonly} loading={true} style={style} />
                </Form.Item>
            }
        </>
    );

    const FieldDynamicList = useMemo(() => DynamicListEntity<T, K, M>(), []);

    return (
        <Suspense fallback={fallback}>
            {
                <Form.Item
                    name={field.name}
                    label={field.title}
                    rules={[{ required: field.isRequired, message: message || 'Fill out' }]}
                >
                    <FieldDynamicList disabled={false} style={style} {...restProps} />
                </Form.Item>
            }
        </Suspense>
    );
};

export default memo(FieldDynamicListEntity);
